var $6a504d44fd7ebeaa$exports = {};
$6a504d44fd7ebeaa$exports = {
    "help": `\u{392}\u{3BF}\u{3AE}\u{3B8}\u{3B5}\u{3B9}\u{3B1}`,
    "info": `\u{3A0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}`
};


export {$6a504d44fd7ebeaa$exports as default};
//# sourceMappingURL=el-GR.mjs.map
